export const tryJsonStringify = (...args: Parameters<typeof JSON.stringify>) => {
  try {
    return JSON.stringify(...args);
  } catch (e) {
    return `JSON.stringify failed ${e}`;
  }
};
